import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { AnimatedStats } from './components/AnimatedStats';
import { FundingTypes } from './components/FundingTypes';
import { InteractiveTimeline } from './components/InteractiveTimeline';
import { FundingComparison } from './components/FundingComparison';
import { BusinessTypesGrid } from './components/BusinessTypesGrid';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { MultiStepForm } from './components/MultiStepForm';
import { InteractiveFAQ } from './components/InteractiveFAQ';
import { Footer } from './components/Footer';
import { MobileBottomCTA } from './components/MobileBottomCTA';
export function App() {
  return <div className="w-full min-h-screen bg-black font-sans text-white selection:bg-white selection:text-black" data-id="element-0">
      <Navigation data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <MultiStepForm data-id="element-4" />
        <AnimatedStats data-id="element-5" />
        <FundingTypes data-id="element-6" />
        <InteractiveTimeline data-id="element-7" />
        <FundingComparison data-id="element-8" />
        <BusinessTypesGrid data-id="element-9" />
        <Testimonials data-id="element-10" />
        <About data-id="element-11" />
        <InteractiveFAQ data-id="element-12" />
      </main>

      <Footer data-id="element-13" />

      {/* Overlays & Widgets */}
      <MobileBottomCTA data-id="element-14" />
    </div>;
}